module.exports = __webpack_public_path__ + "img/the_7_habits_of_highly_effective_people.e7122f2f.jpg";